import { render, staticRenderFns } from "./ExchangeMain.vue?vue&type=template&id=331a66ef&"
import script from "./ExchangeMain.vue?vue&type=script&lang=js&"
export * from "./ExchangeMain.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports